import React from 'react';

import BetBuilderIcon from '@swf/sports/components/BetBuilderIcon/BetBuilderIcon';

import styles from './BetBuilderTab.scss';

interface Props {
  isActive: boolean;
  name: string;
}

const BetBuilderTab: React.FC<Props> = ({ isActive, name }) => (
  <div className={styles.container}>
    <BetBuilderIcon isActive={isActive} />
    {name}
  </div>
);

export default BetBuilderTab;
